import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {FondsPortfolioData} from '../../../../models/fondsPortfolioData';
import {FondsService} from '../../../../services/fonds.service';

@Component({
    selector: 'lv-portfolio-uebersicht',
    templateUrl: './portfolio-uebersicht.component.html',
    styleUrls: ['./portfolio-uebersicht.component.scss'],
    standalone: false
})
export class PortfolioUebersichtComponent implements OnInit {
  public fondsPortfolioData$: Observable<FondsPortfolioData>;

  constructor(private _fondsService: FondsService) { }

  ngOnInit(): void {
    this.fondsPortfolioData$ = this._fondsService.fondsPortfolioData$;
  }

}
